module.exports = __webpack_public_path__ + "img/Symbol_0.c8f2fa4c.png";